export const IMAGES = {
  NOOKLE_ICON: '/images/nookleicon.png',
  NOTIFICATION: '/images/notification.png',
  GLASSES: '/images/glasses.png',
  BACK: '/images/back.png',
  EXIT: '/images/exit.png',
};